import React from 'react';
import PropTypes from 'prop-types';
import Helpers from '../../../../helpers/helperFunctions';

const HorseNumbers = ({ horses }) => horses.length ? (
    <div className="outgoing-numbers-wrap">
        <p className='result'>Result</p>
        <ul className="outgoing-numbers">
            {horses.map(item => <li className="racing-number" key={item}>{Helpers.getWithOrdinalSuffix(item)}</li>)}
        </ul>
    </div>
) : null;

HorseNumbers.propTypes = {
    horses: PropTypes.array.isRequired,
};

export default HorseNumbers;